module.exports = __webpack_public_path__ + "img/totalsubjects.37a74dff.png";